const action = require('../action/action');

const copyText = Object.assign({}, action, {

    act: function () {
        if (typeof this.hm.app.components[this.target] !== typeof undefined) {
            let targetComponent = this.hm.app.components[this.target];

            let text = false;

            if (typeof targetComponent.rawValue !== typeof undefined) {
                text = targetComponent.rawValue;
            } else {
                text = targetComponent.getValue();
            }

            text = String(text);

            navigator.clipboard.writeText(text);

            confirmMessage = {
                type: 'info',
                text: 'textCopiedToClipboard'
            };

            this.hm.msgs.show(confirmMessage);
        }
    }
});

module.exports = copyText;